import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { for: "stock" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-caret-down" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("stock.available")), 1),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDataTable && _ctx.toggleDataTable(...args))),
      class: "p-inputgroup cursor-pointer"
    }, [
      _createVNode(_component_InputText, {
        disabled: "",
        id: "stock",
        "model-value": _ctx.label,
        class: _normalizeClass({ 'p-invalid': _ctx.hasError })
      }, null, 8, ["model-value", "class"]),
      _hoisted_3
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "stock_op2",
      appendTo: "body",
      showCloseIcon: true,
      id: "stock_overlay_op2",
      style: {"width":"450px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: _ctx.stocks,
          selection: _ctx.selected,
          "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected) = $event)),
          selectionMode: "single",
          rows: _ctx.stocks.length,
          onRowSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelect($event.data.id))),
          responsiveLayout: "scroll"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "inclTax",
              header: _ctx.$t('stock.price'),
              sortable: true,
              "sort-field": "inclTax"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_NumberFormatter, {
                  value: data.inclTax
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "quantity",
              header: _ctx.$t('stock.stock'),
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_NumberFormatter, {
                  value: data.quantity
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "expiredAt",
              header: _ctx.$t('stock.expiredAt'),
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data.expiredAt && _ctx.$d(data.expiredAt)), 1)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["value", "selection", "rows"])
      ]),
      _: 1
    }, 512)
  ]))
}